import { render, staticRenderFns } from "./ButtonGroupBasic.vue?vue&type=template&id=0b640ece"
import script from "./ButtonGroupBasic.vue?vue&type=script&lang=js"
export * from "./ButtonGroupBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports